//Libraries
import clsx from "clsx";
import { Grid, SvgIcon } from "@mui/material";

//Components
import SimpleDoubleChecking from "@/Layouts/components/Buttons/SimpleDoubleChecking";
import HierarchicalSelector from "@/Layouts/components/HierarchicalSelector";

//Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as TrashIcon } from "@/assets/icons/common/trash-icon.svg";

//Types
import { IPayrollProviderGenericOption } from "@/Settings/types/PayrollMapping/api";
import { TSelectedValuesInput } from "@/Layouts/types/HierarchicalSelector";

type InputSectionProps = {
	index: {
		itemIndex: number;
		inputIndex: number;
	};
	inputValues: TSelectedValuesInput[];
	options: IPayrollProviderGenericOption<any>[];
	mapFunction?: (item: any) => { name: string; id: string };
	disabled: boolean;
	onChange: (payItemIndex: number, inputIndex: number, value?: TSelectedValuesInput) => void;
	onRemoveInput: () => void;
};
export default function InputSection(props: Readonly<InputSectionProps>) {
	const { index, disabled, inputValues, options, mapFunction, onRemoveInput, onChange } = props;

	function handleOnChange(newValue?: TSelectedValuesInput) {
		onChange(index.itemIndex, index.inputIndex, newValue);
	}
	return (
		<Grid item className="!flex" xs={3} alignItems="center">
			<HierarchicalSelector
				value={inputValues.filter((item) => item.value && item.label)}
				disabled={disabled}
				options={options.map((opt) => ({
					displayLabel: opt.displayId,
					id: opt.companyId,
					items: opt.items,
				}))}
				mapFunction={mapFunction}
				className={{ textField: "advanced-select regular-input-text", autocomplete: "!w-full" }}
				onChange={handleOnChange}
			/>
			<SimpleDoubleChecking
				disabled={disabled}
				color={"var(--gray-blue-color)"}
				confirmationButtonColor={"var(--gray-blue-color)"}
				icon={<CloseRoundedIcon fontSize="small" className={clsx({ "!text-disabled": disabled })} />}
				iconHover={<CloseRoundedIcon fontSize="small" />}
				confirmationIcon={<SvgIcon className="!text-[22px] !relative !left-[3px] !top-[1.5px]" component={TrashIcon} />}
				onDeleteAction={() => onRemoveInput()}
			/>
		</Grid>
	);
}
